module.exports = __webpack_public_path__ + "0a3e3d6ce6a68572451cf0a32478c807.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/bg.jpg
// module id = 265
// module chunks = 0